import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CardAuthenticationType, PaginatedResponse } from '@finxone-platform/shared/sys-config-types';
import { Observable, catchError } from 'rxjs';
import { ConfigService } from '../config-service/config-service.service';

@Injectable({
  providedIn: 'root',
})
export class CardAuthenticationService {
  private baseUrl = '';

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {
    this.configService.getApi('account_service').subscribe((response) => {
      this.baseUrl = response;
    });
  }

  getCardAuthentication(authenticationId: string): Observable<CardAuthenticationType> {
    return this.http
      .get<CardAuthenticationType>(`${this.baseUrl}/card-authentications/${authenticationId}`)
      .pipe(
        catchError((error) => {
          console.error(`Error getting card authentication ${authenticationId}:`, error);
          throw error;
        }),
      );
  }

  listCardAuthentications(params?: {
    status?: string;
    cardId?: string;
    page?: number;
    size?: number;
  }): Observable<PaginatedResponse<CardAuthenticationType>> {
    return this.http
      .get<PaginatedResponse<CardAuthenticationType>>(`${this.baseUrl}/card-authentications`, {
        params: params ?? {},
      })
      .pipe(
        catchError((error) => {
          console.error('Error listing card authentications:', error);
          throw error;
        }),
      );
  }

  approveCardAuthentication(authenticationId: string): Observable<CardAuthenticationType> {
    return this.http
      .post<CardAuthenticationType>(`${this.baseUrl}/card-authentications/${authenticationId}/approve`, {})
      .pipe(
        catchError((error) => {
          console.error(`Error approving card authentication ${authenticationId}:`, error);
          throw error;
        }),
      );
  }

  rejectCardAuthentication(authenticationId: string): Observable<CardAuthenticationType> {
    return this.http
      .post<CardAuthenticationType>(`${this.baseUrl}/card-authentications/${authenticationId}/reject`, {})
      .pipe(
        catchError((error) => {
          console.error(`Error rejecting card authentication ${authenticationId}:`, error);
          throw error;
        }),
      );
  }
}
